up.compiler('pre', (element: HTMLElement) => {
  void import('highlight.js/lib/core').then(({ default: Highlight }) => {
    Highlight.configure({
      // We sanitize our HTML on the server side (e.g. Wordpress Sanitize HTML Parser), but the Company#internal_profile_html
      // can inject unsafe HTML from Studyflix employees. Since we need to allow HTML from the Wordpress articles (e.g. styles)
      // we can not disable HTML for hightlight.js in general. Company#internal_profile_html is considered to be removed and
      // will help to reduce the attack surface.
      ignoreUnescapedHTML: true,
    })

    Highlight.addPlugin({
      'before:highlightElement': ({ el }: { el: Element; language: string }) => {
        el.textContent = (el as HTMLElement).innerText
      },
    })

    const languagePromises: Promise<void>[] = []
    languagePromises.push(
      import('highlight.js/lib/languages/cpp').then(function (language) {
        Highlight.registerLanguage('cpp', language.default)
      }),
    )

    languagePromises.push(
      import('highlight.js/lib/languages/basic').then(function (language) {
        Highlight.registerLanguage('basic', language.default)
      }),
    )

    languagePromises.push(
      import('highlight.js/lib/languages/java').then(function (language) {
        Highlight.registerLanguage('java', language.default)
      }),
    )

    languagePromises.push(
      import('highlight.js/lib/languages/python').then(function (language) {
        Highlight.registerLanguage(
          'python',
          language.default as unknown as Parameters<typeof Highlight.registerLanguage>[1],
        )
      }),
    )

    void Promise.all(languagePromises).then(function () {
      Highlight.highlightElement(element)
    })
  })
})
